import React, { useContext, createContext, PropsWithChildren, useMemo } from 'react'
import { Iata, OpCoConfig } from '@reward-platform/shared-schemas'
import { getOpCoMetaConfig } from '~/utils/platform'
import { PlatformError } from '~/utils/errors'

// TODO: rename file and exports from 'Partner' to 'OpCo' or 'Platform'

type PartnerContextValue = {
  code: OpCoConfig['iataCode']
  tag: OpCoConfig['key']
  name: OpCoConfig['name']
}

type ProviderProps = {
  opCo: Iata
}

const PartnerContext = createContext<PartnerContextValue | undefined>(undefined)

export const usePartner = () => {
  const partner = useContext(PartnerContext)

  if (!partner) {
    throw new PlatformError('usePartner must be used within PartnerProvider')
  }

  return partner
}

export const PartnerProvider = ({ children, opCo }: PropsWithChildren<ProviderProps>) => {
  const contextValue = useMemo<PartnerContextValue>(() => {
    const opCoMeta = getOpCoMetaConfig(opCo)
    return {
      code: opCo,
      name: opCoMeta.name,
      tag: opCoMeta.id,
    }
  }, [opCo])

  return <PartnerContext.Provider value={contextValue}>{children}</PartnerContext.Provider>
}
